import { useScoutAgentChatById } from 'hooks/useScoutAgent';
import type { Session } from 'services/API/AIInteractionAPI';

/** Loads the Scout chat a saved search was created/edited from, by its adk_session_id. */
export const useSavedSearchChatSession = (
  sessionId: string | null | undefined,
): { session: Session | undefined; isLoading: boolean } => {
  const { data, isLoading } = useScoutAgentChatById(sessionId ?? null);

  return { session: data ?? undefined, isLoading };
};
